<div class="wrap">
    <h2>Ajouter une caméra</h2>
    <form [formGroup]="addCameraForm" #addCamera (ngSubmit)="onSubmit()" *ngIf="!confirmAdd">
      <mat-form-field class="example-full-width">
        <mat-label>{{'addCamera.name.label' | translate}}</mat-label>
        <input matInput formControlName="name" (input)="isInactive()">
        <mat-error>{{'addCamera.name.erromMessage' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class=" example-full-width">
        <mat-label>{{'addCamera.ip.label' | translate}}</mat-label>
        <input matInput formControlName="ip" (input)="isInactive()">
        <mat-error>{{'addCamera.ip.erromMessage' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>{{'addCamera.port.label' | translate}}</mat-label>
        <input matInput formControlName="port" id="port" (input)="isInactive()">
        <mat-error>
          {{'addCamera.port.erromMessage.pattern' | translate}}
        </mat-error>
        <!-- <mat-error *ngIf="addCameraForm.hasError('required')">
          {{'addCamera.port.erromMessage.required' | translate}}
        </mat-error> -->
      </mat-form-field>
      <button type=" submit" [ngClass]="{isInactive: inactive, isActive: !inactive }" [disabled]="inactive">
        Ajouter</button>
      <button class="canceled" type="button" (click)="dialog.closeAll()">Annuler</button>
    </form>
  
    <div class="confirm" *ngIf="confirmAdd">
      <div class="validation_mail">
        <div class="check">
          <span class="icon-line line-tip"></span>
          <span class="icon-line line-long"></span>
          <div class="icon-circle"></div>
          <div class="icon-fix"></div>
        </div>
      </div>
      <h4>{{'addCamera.confirmAdd.label' | translate}}</h4>
    </div>
  </div>
  